<template>
  <validation-provider v-slot="{ valid, errors }" :rules="rules" :name="validateName || label">
    <div class="mb-3">
      <label v-if="label">{{ label }}
        <span :class="requiredClass">{{ requiredName }}</span>
      </label>
      <d-select-input
          :disabled="disabled"
          :type="type"
          :value="value"
          :options="options"
          :text-field="textField"
          :value-field="valueField"
          :placeholder="placeholder"
          @input="inputChange"
          :state="errors[0] ? false : valid ? true : null"
          style="width: 100%"
          class="d-input mt--1"
          :class="errors[0] ? 'd-input-error' : valid ? 'd-input-success' : ''"
      />
      <div class="text-danger font-12">{{ errors[0] }}</div>
    </div>
  </validation-provider>
</template>

<script>
import ElementMixin from '@/mixins/ElementMixin'
import DSelectInput from "@/components/input/DSelectInput";

export default {
  name: 'DFormSelect',
  components: {DSelectInput},
  props: {
    value: {},
    options: {},
    placeholder: {},
    type: {},
    label: {},
    textField: {},
    valueField: {},
    disabled: false,
    rules: {
      default: '',
    },
  },
  mixins: [ElementMixin],
  computed: {
    requiredClass() {
      return this.isRequired ? 'text-danger' : 'text-muted'
    },
    requiredName() {
      return this.isRequired ? '*' : ''
    },
    isRequired() {
      return this.rules.includes('required')
    },
  },
  methods: {
    inputChange(value) {
      this.$emit('input', value)
    },
  },
}
</script>
